import type { PharmacyTimeZone } from './api.ts'

/**
 * What a zone's clock shows at an instant, `HH:MM`: how the account page lets
 * whoever picks a zone check it against the pharmacy's own clock (#674).
 */
export function clockIn(zone: PharmacyTimeZone, at: Date): string {
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: zone,
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(at)
}
